import { render, staticRenderFns } from "./title_edittd.vue?vue&type=template&id=10096424&scoped=true"
import script from "./title_edittd.vue?vue&type=script&lang=js"
export * from "./title_edittd.vue?vue&type=script&lang=js"
import style0 from "./title_edittd.vue?vue&type=style&index=0&id=10096424&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10096424",
  null
  
)

export default component.exports